import type { DeepRequired } from '../fixtures.types'

const clientHealthInfo: DeepRequired<ClientHealthInfo> = {
  __typename: 'ClientHealthInfo',
  alcohol_consumption_gp_referral: null,
  alcohol_consumption_units_per_week: null,
  cancer_diagnosis: null,
  cancer_requiring_surgery: null,
  chronic_kidney_failure: null,
  chronic_respiratory_disease: null,
  cigarettes_consumption: null,
  cirrhosis: null,
  client_has_no_condition: null,
  current_medication_intake: null,
  client_has_no_family_medical_history: null,
  dementia: null,
  diabetes: null,
  early_retirement_due_to_ill_health: null,
  family_cancer: null,
  family_diabetes: null,
  family_cardiomyopathy: null,
  family_heart_attack: null,
  family_kidney_disease: null,
  family_medical_history_additional_details: null,
  family_medical_history_do_not_know: null,
  family_muscular_dystrophy: null,
  family_neurological_disorder: null,
  family_other_family_medical_condition: null,
  gp_additional_notes: null,
  gp_address: null,
  gp_has_access_to_english_medical_records: null,
  gp_name: null,
  gp_phone_number: null,
  gp_registration_status: null,
  has_smoked_in_the_past: null,
  hazardous_sports_or_hobbies: null,
  heart_attack: null,
  heart_disease: null,
  heart_valve_replacement: null,
  hepatitis_c: null,
  high_blood_pressure: null,
  hiv: null,
  depression: null,
  anxiety_or_panic: null,
  bipolar_psychosis_schizophrenia: null,
  other_mental_health_condition: null,
  muscle_bone_joint_condition: null,
  medical_appointment_in_last_twelve_months: null,
  mini_stroke: null,
  motor_neurone_disease: null,
  multiple_sclerosis: null,
  medical_history_additional_details: null,
  motorbike_for_transport: null,
  organ_transplant: null,
  other_medical_condition: null,
  other_nicotine_consumption_details: null,
  parkinson: null,
  peripheral_vascular_disease: null,
  planned_medical_appointments_or_test_results: null,
  receives_payment_for_sport_participation: null,
  recreational_drug_use: null,
  rolling_tobacco_consumption: null,
  stopped_smoking_date: null,
  stroke: null,
  vape_consumption: null,
}

export default clientHealthInfo
